import {
  Avatar,
  Button,
  Container,
  CssBaseline,
  makeStyles,
  TextField,
  InputLabel,
  FormControl,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import React, { useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  emailSignInStart,
  googleSignInStart,
} from "../../redux/user/user.actions";
import { selectUserError } from "../../redux/user/user.selector";
import ErrorMessage from "../form-inputs/error-message.component";
import { auth } from "../../utils/firebase/firebase.util";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 0),
  },
  button: {
    margin: theme.spacing(4, 0, 2),
  },
}));
const SignIn = ({ emailSignInStart, error }) => {
  const classes = useStyles();
  const [showPwResetForm, setShowPwResetForm] = useState(false);
  const [pwResetError, setPwResetError] = useState("");
  const [values, setValues] = useState({
    email: "",
    password: "",
    showPassword: "",
  });
  const { email, password } = values;
  const handleSubmit = async (event) => {
    event.preventDefault();
    emailSignInStart(email, password);
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClosePwReset = () => {
    setShowPwResetForm(false);
    setPwResetError("");
  };
  return (
    <Container component="main" maxWidth="xs">
      <Dialog open={showPwResetForm} onClose={handleClosePwReset}>
        <DialogTitle>Passwort zurücksetzen:</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Bitte geben sie ihre E-Mail-Adresse ein, um ihr Passwort
            zurückzusetzen:
          </DialogContentText>
          <DialogContentText style={{ color: "red" }}>
            {pwResetError ? pwResetError : null}
          </DialogContentText>
          <TextField
            id="email"
            label="E-Mail-Adresse"
            onChange={handleChange("email")}
            value={values.email}
            fullWidth
            margin="normal"
            autoComplete="email"
            autoFocus
          ></TextField>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className={classes.button}
            fullWidth
            color="secondary"
            onClick={handleClosePwReset}
          >
            Abbrechen
          </Button>
          <Button
            variant="contained"
            className={classes.button}
            fullWidth
            color="primary"
            onClick={() =>
              auth
                .sendPasswordResetEmail(values.email, {
                  url: "https://ideen-saeen.web.app/signin",
                })
                .then(handleClosePwReset)
                .catch((e) =>
                  setPwResetError("Die angegebene E-Mail-Adresse ist falsch!")
                )
            }
          >
            Passwort zurücksetzen
          </Button>
        </DialogActions>
      </Dialog>
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography variant="body1">
          Melden sie sich mit Ihrer Email-Adresse und Ihrem Passwort an
        </Typography>
        <ErrorMessage error={error} />

        <form onSubmit={handleSubmit} noValidate className={classes.form}>
          <TextField
            id="email"
            label="E-Mail-Adresse"
            onChange={handleChange("email")}
            required
            value={values.email}
            fullWidth
            margin="normal"
            autoComplete="email"
            autoFocus
          />
          <FormControl fullWidth required margin="normal">
            <InputLabel htmlFor="password">Passwort</InputLabel>
            <Input
              id="password"
              type={values.showPassword ? "text" : "password"}
              value={values.password}
              margin="normal"
              fullWidth
              onChange={handleChange("password")}
              autoComplete="current-password"
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="password anzeigen"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <Button
            type="submit"
            variant="contained"
            className={classes.submit}
            fullWidth
            color="primary"
          >
            Anmelden
          </Button>
          <Button
            variant="contained"
            className={classes.button}
            fullWidth
            color="primary"
            onClick={() => setShowPwResetForm(true)}
          >
            Passwort zurücksetzen
          </Button>
        </form>
      </div>
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => ({
  googleSignInStart: () => dispatch(googleSignInStart()),
  emailSignInStart: (email, password) =>
    dispatch(emailSignInStart({ email, password })),
});

const mapStateToProps = createStructuredSelector({
  error: selectUserError,
});
export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
